import { CompanyProductPlan } from '@nicejob-library/enums';

/**
 * @note the order is important
 */
export const PAID_COMPANY_PRODUCT_PLANS = [
    CompanyProductPlan.LITE,
    CompanyProductPlan.WIDGETS,
    CompanyProductPlan.STANDARD,
    CompanyProductPlan.PRO,
];

export { CompanyProductPlan, CompanyProductPlanDate } from '@nicejob-library/enums';
